import moment from "moment";
import store from "@/store";

export function searchDay(){
  let tmp = new Date()
  let currentDate = moment(`${tmp.getUTCDate()}/${tmp.getUTCMonth() + 1}`, 'DD/MM')

  // Navidad
  let minDate = moment( '01/12', 'DD/MM')
  let maxDate = moment( '31/12', 'DD/MM')
  let maxDateB = moment( '07/01', 'DD/MM')

  // console.log("val:", minDate, maxDate, currentDate)
  if((currentDate.isSameOrAfter(minDate) && currentDate.isSameOrBefore(maxDate)) || currentDate.isSameOrBefore(maxDateB)){
    return 'Navidad'
  } else {
    store.commit('changeSpecialDay', false)
    return ''
  }
}
